/**
 * @file track-internal-links.js
 * @description This script tracks clicks on internal links on the webpage.
 * It sets up event listeners to handle clicks on specific elements and dispatches a segment event.
 *
 * @requires jQuery
 */
if (typeof jQuery !== "undefined")
  jQuery(document).ready(function ($) {
    // add click listener for all engagement buttons
    document.addEventListener("click", function (e) {
      // get the a that was clicked
      const element = e.target.closest("a");

      if (!element) {
        return;
      }

      // get the text of the element
      const imgAlt = element.querySelector("img")?.alt?.trim();
      const text = element.textContent?.trim() || imgAlt || "No text";
      const title = element.title?.trim() || text;


      // if the element does not have an href, return
      if (!element.hasAttribute("href")) {
        return;
      }

      // check if the links is not a google or apple play store link
      const storeMatch = element.href.match(
        /(play\.google\.com|apps\.apple\.com)/
      );

      // check if the link is an internal link
      const internalLinkMatch = isInternalLink(element.href);

      // if the link is a store link or if it's an internal link, return
      if (storeMatch || !internalLinkMatch) {
        return;
      }

      // if the link is internal but has the btn class, return - this should be an engagement track probably
      if (internalLinkMatch && element.classList.contains("btn")) {
        return;
      }

      // match if the link is an enter enrollment CTA
      const isEnterEnrollmentCta =
        (e.target.href &&
          e.target.href.match(
            /(member\.chime|test\.1debit)\.com\/(signup|enroll)/
          )) ||
        e.target.matches(".email-capture-submit");

      // or a home nav item
      const isHomeNavItem =
        (e.target.matches("#header .menu-item a") &&
          !e.target.matches(".apply a")) ||
        e.target.matches(".header__nav-btn--open");

      // if the link is a home nav item or an enter enrollment CTA, return
      if (isHomeNavItem || isEnterEnrollmentCta) {
        return;
      }

      const segmentAttributes = getModuleTrackingAttributes(element);

      const moduleData = extractModuleData(segmentAttributes);     

      const destination = element.href;
      const location = window.location.href;

      const $element = $(element);

      const conditions = [
        {
          check: () =>
            $element.parents(".hero, .referral, .landing-page").length > 0,
          value: "hero",
        },
        {
          check: () => $element.parents(".footer").length > 0,
          value: "footer",
        },
        {
          check: () => $element.parents(".blog-nav").length > 0,
          value: "blog navigation",
        },
        {
          check: () => $element.parents(".blog-related-links").length > 0,
          value: "blog-related-article",
        },
        {
          check: () => $element.parents(".table-of-contents").length > 0,
          value: "table-of-contents",
        },
        {
          check: () => matchPartialClassByString(element.classList, "author"),
          value: "article-author",
        },
        {
          check: () => matchPartialClassByString(element.classList, "bread"),
          value: "breadcrumb",
        },
      ];

      // finds the linkType based on the conditions stated above
      const linkType =
        conditions.find((condition) => condition.check())?.value ||
        "communication";

      const attributes = [
        ...segmentAttributes,
        ...convertObjectToArray({
          destination,
          label: text,
          button_name: text,
          link_type: linkType,
          ...getAdditionalTrackingProperties(),
        }),
      ];

      segmentGenericEvent("track", {
        interaction_type: "INTERACTION_TYPE_INTERNAL_LINK_TAPPED",
        interaction_details: {
          location: location,
          action_detail: title || text,
        },
        additional_data: attributes,
      });

      // Analytics SDK double fire
      fireAnalyticsEvent(Track.WebItemClicked, {
        unique_id: 'internal_link_tapped',
        label: title || 'No text',
        element_type: 'ELEMENT_TYPE_LINK',
        item_value: destination,
        item_details: {
          "internal_link_tapped": {
            "module": {
              ...moduleData,
            },
            "link_type": linkType,
          }
        }
      });
    });
  });
